//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { events, util } from "@nuskin/ns-util";
import { UserService, AccountManager } from "@nuskin/ns-account";
import { NsIcon } from "@nuskin/design-components";

import vueEventBus from "../EventBus";

export default {
  name: "NsMinimalHeaderProfileToggle",
  components: {
    NsIcon
  },
  props: {
    /**
     * Greeting template from translations
     */
    greeting: {
      type: String,
      default: "Hi %username%"
    },
    signInLabel: {
      type: String,
      default: ""
    },
    signUpLabel: {
      type: String,
      default: ""
    },
    signUpHref: {
      type: String,
      default: ""
    },
    signOutLabel: {
      type: String,
      default: "Sign Out"
    },
    /**
    /**
     * The url where signout link takes you
     */
    signOutUrl: {
      type: String,
      default: ""
    },
    profileUrl: {
      type: String,
      default: ""
    },
    /**
     * Compact mode. Hide buttons
     */
    compact: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    user: null
  }),
  computed: {
    desktop() {
      return this.$mq === "desktop" || this.$mq === "desktopHD";
    },
    greetingText() {
      let displayName = this.user.getDisplayName();
      return this.greeting
        .replace("<br>", " ")
        .replace("%username%", displayName);
    }
  },
  mounted() {
    this.addListeners();
    this.setUser();
  },
  beforeDestroy() {
    this.removeListeners();
  },
  methods: {
    setUser() {
      const isLoggedIn = UserService.isLoggedIn();
      if (!isLoggedIn) {
        this.user = null;
        return;
      }

      this.user = UserService.getUser();
    },

    logout(event) {
      event.preventDefault();
      const signOutUrl =
        this.signOutUrl === "#"
          ? util.getLocaleUrl() + "home.html"
          : this.signOutUrl;
      AccountManager.afterLogoutRedirect = signOutUrl;
      AccountManager.logout();
    },

    signUp() {
      window.location.href = this.signUpHref;
    },

    redirectToProfile() {
      window.location.href = this.profileUrl;
    },

    signIn() {
      events.publish(events.authentication.REQUEST_FOR_LOGIN, {
        href: window.location.href
      });
    },

    /**
     * Subscribe to events, should only be called when mounted
     */
    addListeners() {
      // listen to config changes
      vueEventBus.$on("config-changed", this.setUser);

      // LOGIN EVENTS
      events.subscribe(events.authentication.LOGIN_COMPLETE, this.setUser);
      events.subscribe(events.authentication.LOGOUT, this.setUser);
    },

    /**
     * Unsubscribe from events, should only be called when destroyed
     */
    removeListeners() {
      // stop listening to event bus
      vueEventBus.$off();

      // LOGIN EVENTS
      events.unsubscribe(events.authentication.LOGIN_COMPLETE, this.setUser);
      events.unsubscribe(events.authentication.LOGOUT, this.setUser);
    }
  }
};
